import { NgModule } from '@angular/core';
import { UserPipelines } from './user-pipelines';
import { Observable } from 'rxjs';
import { PARTNER_ID_TOKEN, USER_PIPELINES_SERVICE_CONFIG_TOKEN, UserPipelinesServiceConfig } from './tokens';
import { PipelineCacheModule } from '../pipeline/cache/pipeline-cache.module';

@NgModule({
  imports: [PipelineCacheModule],
  providers: [
    UserPipelines,
    { provide: PARTNER_ID_TOKEN, deps: [USER_PIPELINES_SERVICE_CONFIG_TOKEN], useFactory: partnerIdFactory },
  ],
})
export class UserPipelinesModule {}

function partnerIdFactory(config: UserPipelinesServiceConfig): Observable<string> {
  return config.partnerId$;
}
